<template>
  <div
    class="bg-primary-2-lighter mx-0 m-auto my-7 px-5 py-[50px] md:rounded-[30px] md:h-[528px] overflow-hidden"
    :class="type == 2 ? 'px-3' : 'addition-layout-padding'"
  >
    <div class="md:w-[800px] mx-auto text-center">
      <h2
        class="text-[30px] md:text-heading-2 font-extrabold text-primary-2-darker title-font"
      >
        {{ t("supplier.supportTitle") }}
      </h2>
      <div
        class="text-mobile-paragraph-1 md:text-paragraph-1 text-gray-1 mt-[10px] mb-[30px] md:w-[650px] mx-auto"
      >
        {{ t("supplier.supportDescription") }}
      </div>
    </div>
    <div class="md:flex justify-between" :class="{ 'gap-4': type == 2 }">
      <div class="support-card md:w-5/12 p-[20px] md:p-[30px]">
        <div class="flex">
          <div
            class="border border-white rounded-full p-1"
            :class="{ '!border-star-color': type == 2 }"
          >
            <div
              class="bg-white w-[55px] h-[55px] rounded-full p-[14px]"
              :class="{ '!bg-star-color': type == 2 }"
            >
              <IconLocation
                class="text-[26px] text-primary-2-darker !mb-0"
                :class="{ '!text-white': type == 2 }"
              />
            </div>
          </div>
        </div>
        <div
          class="info-text whitespace-break-spaces"
          :class="{ 'md:!text-heading-5': type == 2 }"
        >
          {{ info?.address.address_description }}
        </div>
      </div>
      <div class="support-card md:w-2/6 overflow-hidden">
        <NuxtImg
          loading="lazy"
          v-no-right-click
          :src="supportImage"
          alt="support"
          class="object-cover w-full h-full opacity-45 absolute"
        />
        <div class="p-[20px] md:p-[30px] relative h-full">
          <div class="flex">
            <div
              class="border border-white rounded-full p-1"
              :class="{ '!border-star-color': type == 2 }"
            >
              <div
                class="bg-white w-[55px] h-[55px] rounded-full p-[14px] flex"
                :class="{ '!bg-star-color': type == 2 }"
              >
                <IconEmail
                  class="text-[24px] text-primary-2-darker !mb-0 mx-auto"
                  :class="{ '!text-white': type == 2 }"
                />
              </div>
            </div>
          </div>
          <a
            class="info-text block"
            :class="{ 'md:!text-heading-5': type == 2 }"
            :href="`mailto:${info?.email}`"
          >
            {{ info?.email }}
          </a>
        </div>
      </div>
      <div class="support-card md:w-[22%] p-[20px] md:p-[30px] max-md:!mb-0">
        <div class="flex">
          <div
            class="border border-white rounded-full p-1"
            :class="{ '!border-star-color': type == 2 }"
          >
            <div
              class="bg-white w-[55px] h-[55px] rounded-full p-[14px] flex items-center"
              :class="{ '!bg-star-color': type == 2 }"
            >
              <IconRing
                class="text-[22px] text-primary-2-darker !mb-0 mx-auto"
                :class="{ '!text-white': type == 2 }"
              />
            </div>
          </div>
        </div>
        <div class="info-text" :class="{ 'md:!text-heading-5': type == 2 }">
          <a
            v-for="(item, index) in info?.telephones"
            :key="index"
            :tel="item"
            :href="`tel:${item}`"
            dir="ltr"
            class="block"
          >
            {{ item }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed, ref } from "vue";
import type { ICompanyInfo } from "../../../types/general";
import { useAsyncData } from "nuxt/app";

defineProps({
  type: { type: Number, default: 1 },
});
const { t } = useI18n();
const config = useRuntimeConfig();
const locale = useCookie("locale").value;
const { data: info } = await useAsyncData<ICompanyInfo | null>(
  `about-${locale}`,
  () => customFetch(`api/company-info?lang=${locale}`)
);

const supportImageSrc =
  (config.public.supplierStatic as any)?.supportImageSrc || null;

const supportImage = computed(() => {
  return supportImageSrc ? supportImageSrc : "/support.png";
});
</script>
<style scoped>
.support-card {
  @apply h-[172px] md:h-[226px] bg-primary-2-darker rounded-[20px] relative max-md:mb-[20px];
  .info-text {
    @apply text-white absolute bottom-4 md:bottom-7 font-extrabold text-[16px] md:text-heading-4 max-md:leading-[21px];
  }
}
</style>
